"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frontRoutes = void 0;
const browser_router_1 = require("@rws-framework/browser-router");
const component_1 = require("./pages/home/component");
const component_2 = require("./pages/register/component");
const management_1 = require("./routes/management");
const component_3 = require("./pages/company/list/component");
const component_4 = require("./pages/settings/general/component");
const settings_1 = require("./routes/settings");
const component_5 = require("./pages/avatar/list/component");
const avatar_1 = require("./routes/avatar");
const account_1 = require("./routes/account");
const backendImport_1 = require("./backendImport");
const component_6 = require("./pages/ai/chat/component");
const aiRoutes_1 = require("./routes/aiRoutes");
const component_7 = require("./pages/user/profile/component");
const component_8 = require("./pages/share/component");
const component_9 = require("./pages/payment/confirmed/component");
const component_10 = require("./pages/password-reset/component");
const component_11 = require("./pages/password-reset-confirm/component");
const component_12 = require("./pages/register-complete/component");
const component_13 = require("./pages/activate-account/component");
const payment_1 = require("./routes/payment");
const component_14 = require("@front/pages/settings/social-media-plan/component");
const component_15 = require("./pages/landing/component");
const component_16 = require("./pages/tutorial/category-list/component");
exports.frontRoutes = [
    {
        path: '/landing',
        name: 'Landing',
        component: component_15.LandingPage,
        inMenu: false
    },
    {
        path: '/',
        name: 'route.dashboard'.t(),
        component: component_1.HomePage,
        icon: 'shop-4',
        inMenu: true
    },
    {
        path: '/ai/chat',
        name: 'route.ai'.t(),
        component: component_6.ChatPage,
        acl: `${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.read}`,
        icon: 'cpu',
        inMenu: true,
        children: aiRoutes_1.aiRoutes
    },
    {
        path: '/company/list',
        name: 'route.companyManagement'.t(),
        component: component_3.CompanyList,
        acl: `${backendImport_1.ACL.aclResources.company}.${backendImport_1.ACL.aclActions.read}`,
        icon: 'hotel',
        inMenu: true,
        children: management_1.managementRoutes
    },
    {
        path: '/settings/general',
        name: 'route.settings'.t(),
        component: component_4.GeneralSettings,
        icon: 'security-settings',
        inMenu: true,
        children: settings_1.settingsRoutes,
        acl: `${backendImport_1.ACL.aclResources.settings_general}.${backendImport_1.ACL.aclActions.read}`,
    },
    {
        path: '/profile',
        name: 'route.profile'.t(),
        component: component_7.UserProfileForm,
        inMenu: false // This is an internal page, not shown in menu
    },
    {
        path: '/register',
        name: 'route.register'.t(),
        component: component_2.RegisterPage
    },
    {
        path: '/settings/social-media-plan',
        name: 'route.settings.socialMediaPlan'.t(),
        component: component_14.SocialMediaPlanPage,
        icon: 'hotel',
        inMenu: true,
        acl: `${backendImport_1.ACL.aclResources.settings_general}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/avatar/list',
        name: 'route.assistants'.t(),
        component: component_5.AvatarList,
        acl: `${backendImport_1.ACL.aclResources.avatar}.${backendImport_1.ACL.aclActions.read}`,
        icon: 'profile',
        inMenu: true,
        children: avatar_1.avatarRoutes
    },
    {
        path: '/tutorial/category/list',
        name: 'route.tutorialCategories'.t(),
        component: component_16.TutorialCategoryList,
        acl: `${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.read}`,
        icon: 'folder',
        inMenu: false
    },
    {
        path: '/share',
        name: 'route.share'.t(),
        component: component_8.ShareConvo,
        inMenu: false // This is a public page, not shown in menu
    },
    {
        path: '/payment/confirmed',
        name: 'route.paymentConfirmed'.t(),
        component: component_9.PaymentConfirmedPage,
        inMenu: false // This is a confirmation page, not shown in menu
    },
    {
        path: '/password-reset',
        name: 'route.passwordReset'.t(),
        component: component_10.PasswordResetPage,
        inMenu: false
    },
    {
        path: '/reset-password/:token',
        name: 'route.passwordResetConfirm'.t(),
        component: component_11.PasswordResetConfirmPage,
        inMenu: false
    },
    {
        path: '/register-complete',
        name: 'route.registerComplete'.t(),
        component: component_12.RegisterCompletePage,
        inMenu: false
    },
    {
        path: '/activate-account/:token',
        name: 'route.activateAccount'.t(),
        component: component_13.ActivateAccountPage,
        inMenu: false
    },
    ...account_1.accountRoutes,
    ...payment_1.paymentRoutes,
];
const routeMap = {};
for (const frontRoute of exports.frontRoutes) {
    if (frontRoute.children) {
        for (const child of frontRoute.children) {
            routeMap[child.path] = (0, browser_router_1.renderRouteComponent)(child.name, child.component);
        }
    }
    else {
        routeMap[frontRoute.path] = (0, browser_router_1.renderRouteComponent)(frontRoute.name, frontRoute.component);
    }
}
exports.default = routeMap;
